import { Configuration, UsersApi } from '@/api';
import CustomToast from '@/components/CustomToast';
import SpinnerIcon from '@/components/icons/SpinnerIcon';
import { User } from '@/models/User';
import { useAuth } from '@/modules/auth/contexts/AuthContext';
import NotificationForm, {
  NotificationFormData,
} from '@/modules/settings/components/NotificationForm';
import SettingsHeader from '@/modules/settings/components/SettingsHeader';
import useUserQuery from '@/modules/settings/hooks/useUserQuery';
import { BellIcon } from '@heroicons/react/24/outline';
import toast from 'react-hot-toast';

const Notification = () => {
  const { user, isLoading, invalidateQuery } = useUserQuery();

  const usersApi = new UsersApi(new Configuration(useAuth));

  const handleSubmitNotification = async (
    user: User,
    notificationFormData: NotificationFormData,
  ) => {
    try {
      await usersApi.updateUser(user.id, {
        ...user,
        settings: {
          ...user.settings,
          notifications: notificationFormData,
        },
      });

      toast.custom((t) => (
        <CustomToast
          id={t.id}
          message={'Notification settings updated successfully!'}
          visible={t.visible}
        />
      ));

      await invalidateQuery();
    } catch (error) {
      console.error('Error while updating user notification settings:', error);
    }
  };

  if (isLoading) {
    return (
      <div className="flex justify-center py-20">
        <SpinnerIcon />
      </div>
    );
  }

  if (!user) {
    return;
  }

  return (
    <>
      <SettingsHeader title="Notifications" icon={<BellIcon className="w-6 h-6" />} />

      <NotificationForm
        value={user.settings?.notifications}
        onSubmit={(value) => handleSubmitNotification(user, value)}
      />
    </>
  );
};

export default Notification;
